import React from 'react'
import Dyson from './dyson/Dyson';
import Selector from './selector/Selector';
import { useParams } from 'react-router-dom';
import SdkBox from './dyson/sdk/SdkBox';
import { isRootOrAbove, useConfigPathContext } from '../../providers/ConfigPathContextProvider';
import { useConfigsDataContext } from '../../providers/ConfigsDataContextProvider';
import './Configs.css'

// -------------------------------  STATIC  ---------------------------------------- //

const isSdkBox = (urlParam) => 'SDK' === urlParam;

// --------------------------------------------------------------------------------- //


 // ------ Configs------//
//                     //
const Configs = () => {
  const {configPath}  = useConfigPathContext();
  const {showSdk}     = useParams();

  // LOAD Configs
  useConfigsDataContext();

  // TODO: If configPath is between "something" and before "end of base" then it is an explicit select on wizard. (user selected one of the steps).
  //       If configPath is empty (never used, never navigated by the user):
  //       - If there is a tree, go to the first base. (this should cover also the initial my-app v1.0.0 dev base)

  // ---  Render  ---
  const showSdkBox = isSdkBox(showSdk);
  const showDyson =  isRootOrAbove(configPath);

  return (
    <div className='configs'>

        {!showDyson && <Selector />}

        {showDyson && <Dyson />}

        { (showSdkBox && showDyson) && <SdkBox />}

    </div>
  )
}

export default React.memo(Configs);